import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.black};
`;

export const Label = styled.label`
  white-space: nowrap;
`;
